import React, { Component } from 'react';
import './HomeFeatures.scss';

class HomeFeatures extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const features = this.props.features.map((item, index) => {
          return (
            <div className="col-12 col-md-4">
              <h4><i className={item.icon} /> {item.title}</h4>
              <p>{item.description}</p>
            </div>
          )
        })
        return (
            <div className='home-features'>

              <div className="container  section_padding_100">
                <div className='text-center'>
                  <h2>{this.props.title}</h2>
                </div>
                <div className="line-shape"></div>
                <div className='row'>
                  {features}
                </div>
              </div>
            </div>
        )
    }
}

export default HomeFeatures;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeFeatures/index.js